export const {REACT_APP_GOOGLE_TRACKING_ID} = process.env;

export const getGoogleClientID = (cb) => {

    if (window.ga) {

        window.ga('create', REACT_APP_GOOGLE_TRACKING_ID, 'auto');

        window.ga(function (tracker) {
            cb(tracker.get('clientId'));
        });
    }
};